<template>
    <div class="container pt-2">
        <PageTitle main="Localização de Motoristas" sub="Consultar a localização dos motoristas em seu último acesso" />
        <b-alert
        :show="dismissCountDown"
        dismissible
        fade
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
        class="my-3"
        ><span>Motorista: {{ item.motorista }}.</span>
        </b-alert>
        <gmap-map
            :center="center"
            :zoom="12"
            style="width:100%;  height: 400px;">
            <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="showPopup(index)"
                @dblclick="centerMap(m)"
                :id="'popover-target-' + index"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
    import { baseApiUrl } from '@/global'
    import axios from 'axios'
    import PageTitle from '@/components/template/PageTitle'
    import { VueEasyJwt } from 'vue-easy-jwt'

    export default {
        name: "mapa",
        components: { PageTitle },
        data() {
            return {
                jwt: new VueEasyJwt(),
                center: { lat: 45.508, lng: -73.587 },
                markers: [],
                item: {},
                tempMarkers: [],
                places: [],
                currentPlace: null,
                level: '',
                quemRecebeu: '',
                dismissSecs: 3,
                dismissCountDown: 0
            };
        },
        mounted() {
            this.validaLogin()
            this.geolocate()
            this.getLocation()
        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showPopup(i) {
                this.item.motorista = this.markers[i].position.motorista
                this.dismissCountDown = this.dismissSecs
            },
            getLocation() {
                const url = `${baseApiUrl}/backend/motoristas.php`
                axios.get(url).then(res => {
                    this.tempMarkers = res.data
                    for (let i = 0; i < this.tempMarkers.length; i++) {
                        const marker = {
                            lat: parseFloat(this.tempMarkers[i].latitude),
                            lng: parseFloat(this.tempMarkers[i].longitude),
                            motorista: this.tempMarkers[i].nome
                        }

                        this.markers.push({ position: marker })
                        
                    }
                    
                    
                    // this.places.push(this.currentPlace)
                    // this.center = marker
                    // this.currentPlace = null
                })
            },
            geolocate: function() {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                    }
                })
            },
            validaLogin() {
                const local = localStorage.getItem('__SYSTEM_USER')
                const decodedToken = this.jwt.decodeToken(local)
                if (local === null) {
                    this.$router.push({ path: '/login' })
                } else {
                    this.level = decodedToken['data'].level
                    this.quemRecebeu = decodedToken['data'].id
                }
            }
        }
    }
</script>